/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseProfileImageResponse } from '../../models/base-profile-image-response';

export interface DeleteBaseProfileImage$Params {
  id: number;
}

export function deleteBaseProfileImage(http: HttpClient, rootUrl: string, params: DeleteBaseProfileImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProfileImageResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteBaseProfileImage.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseProfileImageResponse>;
    })
  );
}

deleteBaseProfileImage.PATH = '/api/scheduler/bases/{id}/profile-image';
